import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
const json = {
  1: {
    unit: "Unit 1",
    id: "SB7-U1-P16-E1",
    audio: "",
    video: "",
    component: T6,
    // protractor: true,
    hideBtnFooter: true,
    animated: true,
    titleQuestion: [
      {
        title: ` 
          
            `,
        color: "rgb(253,200,156)",
      },
    ],
    questions: [
      {
        title: `
        <div style="position: relative;">
            <img  src ='/img/FriendsPlus/Page6/Demo/bang.jpg' style='height:12cm;'/>    

            <img id="image1" src ='/img/FriendsPlus/Page6/Demo/a.png' style="position: absolute; bottom:0;left:0px;width: 140px; opacity:0;"/>     

            <div style="position: absolute; bottom: 222px; left: 160px; font-size: 16px;padding: 5px;">
              <span id="span-text"  style="margin-right: 5px; display: none;">Tớ</span>
              <span  id="span-text" style="margin-right: 5px; display: none;">thấy</span>
              <span  id="span-text" style="margin-right: 5px; display: none;">góc</span>
              <span id="span-text"  style="margin-right: 5px; display: none;">đỉnh</span><br/>
              <span id="span-text"  style="margin-right: 5px; display: none;">O</span>
              <span id="span-text"  style="margin-right: 5px; display: none;">cạnh</span>
              <span id="span-text"  style="margin-right: 5px; display: none;">OA,</span>
              <span id="span-text"  style="margin-right: 5px; display: none;">OB</span>
              <span id="span-text"  style="margin-right: 5px; display: none;">bé</span><br/>
              <span id="span-text"  style="margin-right: 5px; display: none;">hơn</span>
              <span id="span-text"  style="margin-right: 5px; display: none;">góc</span>
              <span id="span-text"  style="margin-right: 5px; display: none;">đỉnh</span>
              <span id="span-text"  style="margin-right: 5px; display: none;">P</span><br/>
              <span id="span-text"  style="margin-right: 5px; display: none;">cạnh</span>
              <span id="span-text"  style="margin-right: 5px; display: none;">PM,</span>
              <span id="span-text"  style="margin-right: 5px; display: none;">PN</span>
            </div>    

            <img id="image2" src ='/img/FriendsPlus/Page6/Demo/b.png' style="position: absolute; bottom:0;right:0px;width: 100px; opacity:0;"/>  

            <div style="position: absolute; bottom: 149px; right: 262px; font-size: 16px;padding: 5px;">
              <span id="span-text2"  style="margin-right: 5px; display: none;">Tớ</span>
              <span id="span-text2"  style="margin-right: 5px; display: none;">thấy</span>
              <span id="span-text2"  style="margin-right: 5px; display: none;">hai</span>
              <span id="span-text2"  style="margin-right: 5px; display: none;">góc</span><br/>
              <span id="span-text2"  style="margin-right: 5px; display: none;">này</span>
              <span id="span-text2"  style="margin-right: 5px; display: none;">bằng</span>
              <span id="span-text2"  style="margin-right: 5px; display: none;">nhau</span>
            </div>    

            <img id="image3" src ='/img/FriendsPlus/Page6/Demo/c.png' style="position: absolute; bottom:24px;right:0px;width: 100px; opacity:0;"/> 

            <div style="position: absolute; bottom: 199px; right: 25px; font-size: 16px;padding: 5px;">
            <span id="span-text3"  style="margin-right: 5px; display: none;">Phải</span>
            <span id="span-text3"  style="margin-right: 5px; display: none;">dùng</span>
            <span id="span-text3"  style="margin-right: 5px; display: none;">thước</span>
            <span id="span-text3"  style="margin-right: 5px; display: none;">đo</span><br/>
            <span id="span-text3"  style="margin-right: 5px; display: none;">góc</span>
            <span id="span-text3"  style="margin-right: 5px; display: none;">để</span>
            <span id="span-text3"  style="margin-right: 5px; display: none;">đo</span>
            <span id="span-text3"  style="margin-right: 5px; display: none;">mỗi</span>
            <span id="span-text3"  style="margin-right: 5px; display: none;">góc</span><br/>
            <span id="span-text3"  style="margin-right: 5px; display: none;">bằng</span>
            <span id="span-text3"  style="margin-right: 5px; display: none;">bao</span>
            <span id="span-text3"  style="margin-right: 5px; display: none;">nhiêu</span>
            <span id="span-text3"  style="margin-right: 5px; display: none;">độ</span><br/>
            <span id="span-text3"  style="margin-right: 5px; display: none;">rồi</span>
            <span id="span-text3"  style="margin-right: 5px; display: none;">so</span>
            <span id="span-text3"  style="margin-right: 5px; display: none;">sánh</span>
            <span id="span-text3"  style="margin-right: 5px; display: none;">thì</span>
            <span id="span-text3"  style="margin-right: 5px; display: none;">mới</span><br/>
            <span id="span-text3"  style="margin-right: 5px; display: none;">biết</span>
            <span id="span-text3"  style="margin-right: 5px; display: none;">được</span>
            </div>    
            
        </div>
                 
              `,
        answer: [],
      },
    ],
  },
  2: {
    unit: "Unit 1",
    id: "SB7-U1-P16-E3",
    audio: "",
    video: "",
    component: T6,
    protractor: [
      {
        decreaseLeft: 190,
        decreaseTop: 220,

        rotateLeftThan0: 40,
        rotateTopThan0: 40,

        rotateLeftLess0: -20,
        rotateTopLess0: 50,

        inputLeft: "825px",
        inputBottom: "103px",
        result: [
          {
            id: 0,
            top: 92,
            left: 45,
            rotate: 0,
          },
          {
            id: 1,
            top: 92,
            left: 43,
            rotate: 121,
          },
          {
            id: 2,
            top: 92,
            left: 527,
            rotate: 0,
          },
          {
            id: 3,
            top: 94,
            left: 527,
            rotate: 121,
          },
        ],
      },
    ],
    hideBtnFooter: true,
    newWords: [
      {
        title: "Tra cứu",
        description: `
        <span>Tra cứu</span>
        
        `,
      },
    ],
    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>hướng dẫn</span>
        
        `,
      },
    ],
    titleQuestion: [
      {
        title: ` 
        <img src ='/img/FriendsPlus/Page6/Demo2/1.jpg' style='height:3cm;margin-left:-80px'/>
            `,
        color: "rgb(253,200,156)",
      },
    ],
    questions: [
      {
        title: `
        <div style="width:1140px">
        
        <div style="position: relative; ">
        <div style="position:absolute; left:190px; top:71px; width=300px"><img src ='/img/FriendsPlus/Page6/Demo2/3.png' /></div>
        <div style="position:absolute; left:673px; top:71px; width=300px"><img src ='/img/FriendsPlus/Page6/Demo2/3.png' /></div>
        
        <div
        style="
          position: absolute;
          left: 238px;
          top: 296px;
          background-color: red;
          width: 12px;
          height: 12px;
          border-radius: 50%;
        "
      ></div>
      <div
        style="
          position: absolute;
          left: 720px;
          top: 296px;
          background-color: red;
          width: 12px;
          height: 12px;
          border-radius: 50%;
        "
      ></div>

        <div id='0' style="position: absolute; top: 76px;left: 346px; background-color: rgb(89, 188, 141); border-radius: 50%; color: white;padding: 2px 6px;display:none">
              <span >60</span>
        </div>
      
      
          <div id='1' style="position: absolute; top: 265px;left: 452px; background-color: rgb(89, 188, 141); border-radius: 50%; color: white;padding: 2px 6px;display:none">
            <span >60</span>
          </div>

          <div id='2' style="position: absolute; top: 75px;left: 831px; background-color: rgb(89, 188, 141); border-radius: 50%; color: white;padding: 2px 6px;display:none">
            <span >60</span>
          </div>

          <div id='3' style="position: absolute; top: 264px;left: 927px; background-color: rgb(89, 188, 141); border-radius: 50%; color: white;padding: 2px 6px;display:none">
            <span >60</span>
          </div>
        
        </div>
        </div>
        <div
          id="protractor"
          style="position: absolute;top: 389px;left: 0px;width: 400px; height: 420px;z-index: 1"
        >
          <img
            src="/img/test/protractor-removebg-preview2.png"
            style="width: 400px"
            alt="image"
          />
        </div>
              `,
        answer: [],
      },
    ],
  },
  3: {
    unit: "Unit 1",
    id: "SB7-U1-P16-E3",
    audio: "Audios/Chúng ta cùng học về góc.mp3",
    video: "",
    component: T6,
    autoPlay: true,
    hideBtnFooter: true,
    questions: [
      {
        title: `
        <div style='position:relative;width:20cm'>
          <div style='position:absolute;top:-190px;left:35px;'>
              <img src ='/img/FriendsPlus/Page6/Demo3/1.png' style='height:6cm'/>
              <div style='position:absolute;top:60px;left:250px;color:rgb(246 106 126);width:15cm;font-weight:bold;font-size:35px'>
              
                GÓC VÀ ĐƠN VỊ ĐO GÓC
              </div>
              <div style='position:absolute;background:rgb(125 208 179);top:201px;left:-180px;text-align:center;border:15px solid;border-radius:30px;padding:10px 50px; color:white;font-weight:900;font-size:35px'>
              
                Bài 7
              </div>
          </div>
        </div>
          <div style='margin-top:170px;margin-left:70px;background:rgb(254 252 208);text-align:center;border:15px solid;width:15cm;border-radius:30px;padding:20px 50px; color:rgb(246 106 126);font-weight:bold;font-size:35px'>
              ĐO GÓC, ĐƠN VỊ ĐO GÓC
          </div>
              `,
        answer: [],
      },
    ],
  },

  // 1: {
  //   unit: "Unit Starter",
  //   id: "FP8-WB-demo-2023-US-P6-E1",
  //   audio: "",
  //   video: "",
  //   component: T6v2,
  //   exerciseKey: "/img/FriendsPlus/Page6/E1/Key/E1answerKey.png",
  //   // isGroup: true,
  //   // hideBtnFooter: true,
  //   maxLength: 6,
  //   inputSize: 90,
  //   isHiddenCheck:true,
  //   stylesTextInput: {
  //     fontSize: "22px",
  //     textAlign: "center",
  //     borderBottom: 0,
  //   },
  //   titleQuestion: [
  //     {
  //       title: `
  //       <div style= "display: flex">
  //         <div style= "background-color: rgb(61,184,187); border-radius: 50%; color: white; width: 39px; text-align: center; margin-right: 15px">1</div>
  //         <div style= "background-color: rgb(248,230,173); border-radius: 5px; width: 50px; text-align: center">Số</div>
  //         <div>?</div>
  //       </div>
  //       `,
  //       color: "rgb(253,200,156)",
  //     },
  //   ],
  //   questions: [
  //     {
  //       title: `
  //         <table style= "margin-top: 5px; text-align: center; font-size: 22px" border= "1">

  //           <tr style= "background-color: rgb(248,230,173)">
  //             <th style= "width: 120px">Viết số</th>
  //             <th style= "width: 80px">Hàng chục nghìn</th>
  //             <th style= "width: 80px">Hàng nghìn</th>
  //             <th style= "width: 80px">Hàng chục</th>
  //             <th style= "width: 80px">Hàng trăm</th>
  //             <th style= "width: 80px">Hàng đơn vị</th>
  //             <th style= "width: 250px">Đọc số</th>
  //           </tr>

  //           <tr>
  //             <td>36.515</td>
  //             <td>3</td>
  //             <td>6</td>
  //             <td>5</td>
  //             <td>1</td>
  //             <td>5</td>
  //             <td style= "text-align: center;padding:5px 5px">Ba mươi sáu nghìn năm trăm mười lăm</td>
  //           </tr>

  //           <tr>
  //             <td> <input id= "0"> </td>
  //             <td>6</td>
  //             <td> <input id= "1"> </td>
  //             <td>0</td>
  //             <td>3</td>
  //             <td> <input id= "2"> </td>
  //             <td style= "text-align: center;padding:5px 5px">Sáu mươi mốt nghìn không trăm ba mươi tư</td>
  //           </tr>

  //           <tr>
  //             <td> <input id= "3"> </td>
  //             <td style= "background-color: rgb(249,246,230)"></td>
  //             <td>7</td>
  //             <td>9</td>
  //             <td> <input id= "4"> </td>
  //             <td> <input id= "5"> </td>
  //             <td style= "text-align: center;padding:5px 5px">Bảy nghìn chín trăm bốn mươi mốt</td>
  //           </tr>

  //           <tr>
  //             <td> <input id= "6"> </td>
  //             <td> <input id= "7"> </td>
  //             <td>0</td>
  //             <td> <input id= "8"> </td>
  //             <td> <input id= "9"> </td>
  //             <td>9</td>
  //             <td style= "text-align: center;padding:5px 5px">Hai mươi nghìn tám trăm linh chín</td>
  //           </tr>
  //         </table>
  //         `,
  //         answer: [ "61.034",
  //                   "1",
  //                   "4",
  //                   "7.941",
  //                   "4",
  //                   "1",
  //                   "20.809",
  //                   "2",
  //                   "8",
  //                   "9", ],
  //     },
  //   ]
  // },
  // 2: {
  //   unit: "Unit Starter",
  //   id: "FP8-WB-demo-2023-US-P6-E1",
  //   audio: "",
  //   video: "",
  //   component: T6v2,
  //   exerciseKey: "/img/FriendsPlus/Page6/E2/Key/E2answerKey.png",
  //   isHiddenCheck:true,
  //   maxLength: 6,
  //   inputSize: 90,
  //   stylesTextInput: {
  //     fontSize: "22px",
  //     textAlign: "center",
  //     // borderBottom: 0,
  //   },
  //   titleQuestion: [
  //     {
  //       title: `
  //       <div style= "display: flex">
  //         <div style= "background-color: rgb(61,184,187); border-radius: 50%; color: white; width: 39px; text-align: center; margin-right: 15px">2</div>
  //         <div>Viết số rồi đọc số, biết số đó gồm:</div>
  //       </div>
  //       `,
  //       color: "rgb(253,200,156)",
  //     },
  //   ],
  //   questions: [
  //     {
  //       title: `
  //         <div style= "display: flex;line-height:2">
  //          <div style= "margin-right: 15px">
  //            <div>a) 4 chục nghìn, 2 nghìn, 5 trăm và 3 chục</div>
  //            <div>b) 8 nghìn, 8 trăm, 8 chục, 8 đơn vị</div>
  //            <div>c) 5 chục nghìn, 7 trăm, 1 chục và 4 đơn vị</div>
  //            <div>d) 9 chục nghìn, 4 nghìn và 5 đơn vị</div>
  //          </div>

  //          <div>
  //            <div> <input id= "0"> </div>
  //            <div> <input id= "1"> </div>
  //            <div> <input id= "2"> </div>
  //            <div> <input id= "3"> </div>
  //          </div>
  //         </div>
  //         `,
  //         answer: [ "42530 | 42 530",
  //                   "8888",
  //                   "50714 | 50 714",
  //                   "94005 | 94 005",
  //                  ],
  //     },
  //   ]
  // },
  // 3: {
  //   unit: "Unit Starter",
  //   id: "FP8-WB-demo-2023-US-P6-E1",
  //   audio: "",
  //   video: "",
  //   component: T6v2,
  //   exerciseKey: "/img/FriendsPlus/Page6/E3/Key/E3answerKey.png",
  //   isHiddenCheck:true,
  //   maxLength: 3,
  //   inputSize: 90,
  //   stylesTextInput: {
  //     fontSize: "23px",
  //     textAlign: "center",
  //     height: 68,
  //     width: 68,
  //     border: "1px solid black",
  //     borderRadius: "10px",
  //   },
  //   titleQuestion: [
  //     {
  //       title: `
  //       <div style= "display: flex">
  //         <div style= "background-color: rgb(61,184,187); border-radius: 50%; color: white; width: 39px; text-align: center; margin-right: 15px">3</div>
  //         <div style= "background-color: rgb(248,230,173); border-radius: 5px; width: 50px; text-align: center">Số</div>
  //         <div>?</div>
  //       </div>
  //       `,
  //       color: "rgb(253,200,156)",
  //     },
  //   ],
  //   questions: [
  //     {
  //       title: `
  //          <div>
  //            <div style= "margin-bottom: 10px"> <span>a) 6 825 = 6000 + 800 + 20 + </span> <input id= "0"> </div>
  //            <div style= "margin-bottom: 10px"> <span>b) 33 471 = 30 000 + 3 000 +</span> <input id= "1"> <span> + 70 + 1 </span> </div>
  //            <div style= "margin-bottom: 10px"> <span>c) 75 850 = 70 000 + 5 000 + 800 + </span> <input id= "2"> </div>
  //            <div style= "margin-bottom: 10px"> <span>d) 86 209 = 80 000 + 6 000 + </span> <input id= "3"> <span> + 9 </span> </div>
  //          </div>
  //         `,
  //         answer: [ "5",
  //                   "400",
  //                   "50",
  //                   "200",
  //                  ],
  //     },
  //   ]
  // },
};

export default json;
